// frontend/src/App.js
// frontend/src/App.js
import React from "react";
import Chat from "./components/chat";

function App() {
  return <Chat />;
}

export default App;
